var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8391,
    cy: 10.8391,
    r: 9.64286,
    fill: "#F4F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 21.2853C8.96526 21.2853 6.97662 20.682 5.28515 19.5518C3.59367 18.4216 2.27533 16.8152 1.49682 14.9358C0.718324 13.0563 0.514632 10.9882 0.911509 8.99294C1.30839 6.99771 2.288 5.16497 3.72649 3.72649C5.16497 2.288 6.99771 1.30839 8.99294 0.911509C10.9882 0.514632 13.0563 0.718324 14.9358 1.49682C16.8152 2.27533 18.4216 3.59367 19.5518 5.28515C20.682 6.97662 21.2853 8.96526 21.2853 10.9996C21.2822 13.7266 20.1976 16.341 18.2693 18.2693C16.341 20.1976 13.7266 21.2822 10.9996 21.2853ZM10.9996 2.18326C9.25588 2.18326 7.55133 2.70033 6.1015 3.66908C4.65166 4.63783 3.52165 6.01475 2.85436 7.62572C2.18708 9.2367 2.01248 11.0094 2.35266 12.7196C2.69284 14.4298 3.53252 16.0007 4.7655 17.2337C5.99849 18.4667 7.56941 19.3063 9.2796 19.6465C10.9898 19.9867 12.7625 19.8121 14.3734 19.1448C15.9844 18.4775 17.3613 17.3475 18.3301 15.8977C19.2988 14.4478 19.8159 12.7433 19.8159 10.9996C19.8132 8.66217 18.8835 6.42125 17.2307 4.76844C15.5779 3.11564 13.337 2.18592 10.9996 2.18326Z",
    fill: "#878A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.859410789f729b0d864ca42d7f7b8eb0.svg";
export { ForwardRef as ReactComponent };